import { render, staticRenderFns } from "./ModalChannelEdit.vue?vue&type=template&id=ec32e886&scoped=true"
import script from "./ModalChannelEdit.vue?vue&type=script&lang=js"
export * from "./ModalChannelEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalChannelEdit.vue?vue&type=style&index=0&id=ec32e886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec32e886",
  null
  
)

export default component.exports